import type { TOC } from '@ember/component/template-only';

import DataManagerCreateNewMergeComponent from 'webapp/components/data-manager/create-new-merge';

const DatamanagerCreateNewMergeRouteTemplate: TOC<object> = <template>
	<DataManagerCreateNewMergeComponent />
</template>;

export default DatamanagerCreateNewMergeRouteTemplate;
